import { system } from 'styled-system';
/**
 * A mixin to create gap properties for flex and grid layouts.
 *
 * This feature is missing from the styled-system library.
 * See: https://github.com/styled-system/styled-system/issues/1159
 */
export const gap = system({
    gap: {
        property: 'gap',
        scale: 'space',
    },
    rowGap: {
        property: 'rowGap',
        scale: 'space',
    },
    columnGap: {
        property: 'columnGap',
        scale: 'space',
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVkLXN5c3RlbS1nYXAuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY3VzdG9tLXByb3BzL3N0eWxlZC1zeXN0ZW0tZ2FwLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxNQUFNLEVBQW1CLE1BQU0sZUFBZSxDQUFDO0FBR3hEOzs7OztHQUtHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sR0FBRyxHQUFHLE1BQU0sQ0FBQztJQUN4QixHQUFHLEVBQUU7UUFDSCxRQUFRLEVBQUUsS0FBSztRQUNmLEtBQUssRUFBRSxPQUFPO0tBQ2Y7SUFDRCxNQUFNLEVBQUU7UUFDTixRQUFRLEVBQUUsUUFBUTtRQUNsQixLQUFLLEVBQUUsT0FBTztLQUNmO0lBQ0QsU0FBUyxFQUFFO1FBQ1QsUUFBUSxFQUFFLFdBQVc7UUFDckIsS0FBSyxFQUFFLE9BQU87S0FDZjtDQUNGLENBQUMsQ0FBQyJ9